module.exports = __webpack_public_path__ + "media/unipod/icon-cost-14bb1664.svg";